// extracted by mini-css-extract-plugin
export default {"wrap":"CustomSelect_wrap__7E+Zz","error":"CustomSelect_error__qP92C"};